export const GaugeChartDummyData = {
  datasets: [
    {
      value: 15.4,
      // 区切り点
      // 30-31,40-41のような区間が出るのはchartjsの仕様上防げない
      // その場合0-30区間と同一定義（ラベル・色）とする
      data: [0, 30, 31, 40, 41, 50, 51, 75, 76, 100],
      backgroundColor: [
        "#ff0000",
        "#ff0000",
        "#ff4500",
        "#ff4500",
        "#ffd700",
        "#ffd700",
        "#adff2f",
        "#adff2f",
        "#32cd32",
      ],
      labels: [
        "POOR",
        "POOR",
        "FAIR",
        "FAIR",
        "GOOD",
        "GOOD",
        "VERY GOOD",
        "VERY GOOD",
        "EXCELLENT",
      ],
      borderWidth: 0,
      label: "",
    },
  ],
};

export const PieChartDummyData = {
  labels: ["EXCELLENT", "VERY GOOD", "GOOD", "FAIR", "POOR"],
  datasets: [
    {
      data: [20.0, 15.0, 25.0, 30.0, 10.0],
      subData: [2.0, 1.5, 2.5, 3.0, 1.0],
      backgroundColor: ["#32cd32", "#adff2f", "#ffd700", "#ff4500", "#ff0000"],
      borderWidth: 1,
      unit: "mi",
    },
  ],
};

export const DegradationChartDummyData = {
  levelBands: [
    {
      yMin: 76,
      yMax: 100,
      color: "rgba(50, 205, 50,1)",
      label: "Good",
      level: 1,
    },
    {
      yMin: 51,
      yMax: 75,
      color: "rgba(173, 255, 47,1)",
      label: "Satisfactory",
      level: 2,
    },
    {
      yMin: 41,
      yMax: 50,
      color: "rgba(255, 215, 0,1)",
      label: "Fair",
      level: 3,
    },
    {
      yMin: 31,
      yMax: 40,
      color: "rgba(255, 69, 0,1)",
      label: "Poor",
      level: 4,
    },
    {
      yMin: 21,
      yMax: 30,
      color: "rgba(255, 0, 0,1)",
      label: "Very Poor",
      level: 5,
    },
    {
      yMin: 11,
      yMax: 20,
      color: "rgba(163, 2, 2,1)",
      label: "Serious",
      level: 6,
    },
    {
      yMin: 1,
      yMax: 10,
      color: "rgba(87, 78, 78,1)",
      label: "Failed",
      level: 7,
    },
  ],
  lineData: [
    { x: 0.0, y: 100.0 },
    { x: 4.5, y: 86.0 },
    { x: 13.2, y: 73.0 },
    { x: 20.0, y: 55.0 },
    { x: 24.5, y: 10.0 },
  ],
  currentData: [{ x: 4.5, y: 86, title:"" }],
  predictionData: [{ x: 13.2, y: 73, title:"" }],
};
